export default {
	tabs: {
		notDefined: 'Tanımlanmamış',
		journal: 'Yevmiye defteri',
		invoice: 'Fatura',
		reconciliation: 'Mutabakat',
		all: 'Tümü'
	}
}